// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"26c7a8a8","453":"bacbbfdf","732":"2fd47612","977":"7bc4fa9c"}[chunkId] + ".chunk.js";
};